import {useContext, useRef} from "react"; // every page needs to import react

import "react-tabs/style/react-tabs.css";

import { Steps } from "intro.js-react";
import { IDEContext } from "./contexts/IDEContext";
import { UiTrainingContext } from "contexts/UiTrainingContext";

import "intro.js/introjs.css";

import { helpTimeline } from "./constants/education";
import { useIsMobile } from "utils/general";


export const UiTraining = () => {
    const uiKey = 'hasSeenIDETraining'
    // if the server doesn't have this training marked as complete
    const { markComplete } = useContext(UiTrainingContext)
    // if someone has hit the helpMode button
    const { helpMode, setHelpMode } = useContext(IDEContext)
    const isMobile = useIsMobile()
    const stepsRef = useRef(null)

    const filteredTimeline = helpTimeline.filter(
      step => !step.element || document.querySelector(step.element)
    )

    return <Steps
      ref={stepsRef}
      enabled={helpMode && !isMobile}
      steps={filteredTimeline}
      initialStep={0}
      options={{
        showBullets: false,
      }}
      onExit={() => {
        setHelpMode(false)
        markComplete(uiKey)
      }}
    />
  }
